import React from 'react';
import { Label, ChoiceGroup, IChoiceGroupOption } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

import styles from '../../styles/component.module.scss';

export interface IChoiceYesNoField {
	label: string;
	description: string;
	onChange: (choice: boolean) => void;
}

export const ChoiceYesNoField = (props: IChoiceYesNoField) => {
	const { t } = useTranslation();

	const changeChoice = (
		ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
		option?: IChoiceGroupOption | undefined
	): void => {
		if (!option) return;
		props.onChange(option.key === 'yes');
	};

	return (
		<div>
			<Label>{props.label}</Label>
			<div>
				<ChoiceGroup
					options={[
						{ key: 'yes', text: t('choice yesno.yes') },
						{ key: 'no', text: t('choice yesno.no') },
					]}
					defaultSelectedKey='no'
					onChange={changeChoice}
				/>
				<p className={styles.descriptionText}>{props.description}</p>
			</div>
		</div>
	);
};
